import { Routes, Route, Navigate } from 'react-router-dom';
import { MeetingFormWrapper } from '../components/MeetingFormWrapper';
import MeetingsPage from '../pages/MeetingsPage';
import UserProfile from '../pages/UserProfile';
import { MentorsTable } from '../components/MentorsTable';
import FamilyProfile from '../pages/FamilyProfile';
import MentorDashboard from '../pages/MentorDashboard';
import AdminDashboard from '../pages/AdminDashboard';
import MeetingHistoryPage from '../pages/MeetingHistoryPage';
import Login from '../pages/Login';
import NewMeetingButton from '../components/NewMeetingButton';
import NotificationList from '../components/NotificationList';
import ForgotPasswordForm from '../components/ForgotPasswordForm';
import ResetPasswordForm from '../components/ResetPasswordForm';
import AddFamilySection from '../components/AddFamilySection';
import MentorSearch from '../components/MentorSearch';
import Dashboard from '../features/calendar/pages/Dashboard';
import CompletedTasksTable from '../components/CompletedTasksTable';
import FamilyDashboard from '../pages/FamilyDashboard';

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/profile/:id" element={<UserProfile />} />
      <Route path="/calendar" element={<Dashboard />} />
      <Route path="/login" element={<Login />} />
      <Route path="/mentorsTable" element={<MentorsTable />} />
      <Route path="/families/:id" element={<FamilyProfile />} />
      <Route path="/profile/:id" element={<UserProfile />} />
      <Route path="/admin-dashboard" element={<AdminDashboard />} />
      <Route path="/mentor-dashboard" element={<MentorDashboard />} />
      <Route path="/calendar" element={<Dashboard />} />
      <Route path="/meetings" element={<MeetingsPage />} />
      <Route path="/meeting-history/:familyId" element={<MeetingHistoryPage />} />
      <Route path="/meeting-form/:familyId" element={<MeetingFormWrapper />} />
      <Route path="/new-meeting" element={<NewMeetingButton />} />
      <Route path="/notification" element={<NotificationList />} />
      <Route path="/forgot-password" element={<ForgotPasswordForm />} />
      <Route path="/reset-password" element={<ResetPasswordForm />} />
      <Route path="/add-family" element={<AddFamilySection />} />
      <Route path="/task-history" element={<CompletedTasksTable />} />
      <Route path="*" element={<Navigate to="/login" />} />
      <Route path='/add-family' element={<AddFamilySection/>} />
      <Route path="/search" element={<MentorSearch />} />
      <Route path="/task-history" element={<CompletedTasksTable />} />
      <Route path="/family-dashboard/:id" element={<FamilyDashboard/>} />

    </Routes>
  );
};

export default Router;
